import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { ZStackChildElement, ZStackChildProps } from "../types";

function ZStackChild<E extends React.ElementType = ZStackChildElement>({
  as,
  asChild = false,
  id,
  zIndex = 0,
  className,
  ...props
}: ZStackChildProps<E>) {
  const Component = resolveElement(asChild, as, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[ZStack.Child] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      id={`ZStack.Child${id ? `-${id}` : ""}`}
      className={cn("absolute inset-0", className, classes)}
      style={{ zIndex }}
      {...native}
    />
  );
}

export default ZStackChild;
